import ApiPortal from './ApiPortal';
import './App.css';


import { useMsal, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { loginRequest } from "./authConfig";

function App() {
  const { instance,accounts } = useMsal();
  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch(e => console.error(e));
  };

  const handleLogout = () => {
    instance.logoutRedirect().catch(e => console.error(e));
  };
  return (
    <div>
      <AuthenticatedTemplate>
        <ApiPortal account={accounts?.[0]} onLogout={handleLogout} />
      </AuthenticatedTemplate>
      
      <UnauthenticatedTemplate>
        <div className="login-page">
          <div className="login-container">
            <div className="login-content">
              <div className="login-header">
              <img src="/logo-white.png" alt="Ostrum Swagger UI" className="login-logo" />
             
              </div>
              
              <div className="login-body">
                 <h3 className="login-title">API Documentation Portal</h3>
                <p className="login-description">Sign in with your Ostrum Microsoft account to access the API documentation</p>
                <button className="login-button microsoft-button" onClick={handleLogin}>
                  <span className="button-icon">🔐</span>
                  Sign In
                </button>
              </div>
              
              <div className="login-footer">
                <p className="footer-text">
                  Copyright © {new Date().getFullYear()}  
                  <a href="https://www.ostrumtech.com/" target="_blank" rel="noopener noreferrer"> Ostrum Tech Limited</a>
                  . All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </UnauthenticatedTemplate>
    </div>
  );
}

export default App;
